import { EuiIcon, EuiFlexGroup, EuiFlexItem, EuiText, EuiSpacer } from "@elastic/eui";
import { APP_STATUS } from "Consts";

const DownOrOffline = ({ status }) => (
  <EuiFlexGroup
    style={{
      backgroundColor: "#6a6da3",
      height: "100vh",
      paddingTop: "10%",
    }}
    alignItems="center"
    direction="column">
    <EuiFlexItem grow={false}>
      <img
        alt="Fortified Data Support"
        height="120"
        src="/ui/images/logos/wisdom_logo.svg"
        width="200"
      />
    </EuiFlexItem>
    {status === APP_STATUS.down && (
      <EuiFlexItem grow={false} style={{ alignItems: "center", textAlign: "center" }}>
        <EuiText
          color="#F8BF3F"
          css={{ fontSize: "var(--fs28)", fontWeight: "700", width: "400px" }}>
          WISdom is currently under going a little self-care.
        </EuiText>
        <EuiSpacer />
        <EuiText size="m" color="white">
          Go ahead. Go outside.
        </EuiText>
        <EuiText size="m" color="white">
          {" "}
          We won’t tell anyone ;)
        </EuiText>
        <EuiSpacer />
        <EuiIcon type="gear" color="white" size="xxl" />
      </EuiFlexItem>
    )}
    {status === APP_STATUS.offline && (
      <EuiFlexItem grow={false} style={{ alignItems: "center", textAlign: "center" }}>
        <EuiText
          color="#F8BF3F"
          css={{ fontSize: "var(--fs28)", fontWeight: "700", width: "400px" }}>
          You are offline please check your internet connection.
        </EuiText>
        <EuiSpacer />
        <EuiIcon type="offline" color="white" size="xxl" />
      </EuiFlexItem>
    )}
  </EuiFlexGroup>
);

export default DownOrOffline;
